import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import flexible from '../../../utils/flexible.js';
import guideBottom from '@/components/guideBottom.vue';
export default {
  name: 'explanation',
  data() {
    return {
      exhibitions: [],
      language: '',
      childList: []
    };
  },
  components: {
    guideBottom
  },
  methods: {
    showExhitonList(item) {
      this.$router.push(`/${this.$route.query.fid == 152288 && this.childList.find(c => {
        return c.parentExhibitonName == item.exhibName;
      }) ? 'childExhibitions' : 'audios'}?fid=${this.$route.query.fid}&exhibCode=${item.code}${this.language ? '&language=en' : ''}`);
      // let now = new Date()
      // now = this.getDate(now)
      // let flag = (now >= this.getDate(item.exhibBegin) && now <= this.getDate(item.exhibEnd)) || (!item.exhibEnd) || (!item.exhibBegin)
      // flag ? this.$router.push(`/${this.$route.query.fid == 152288 && this.childList.find((c) =>{return c.parentExhibitonName == item.exhibName}) ? 'childExhibitions' : 'audios'}?fid=${this.$route.query.fid}&exhibCode=${item.code}${this.language ? '&language=en' : ''}`) : alert('暂不在开放时间');
    },
    getDate(date) {
      return Date.parse(date);
    },
    getData() {
      const _this = this;
      let searchStr = {
        filters: [[{
          "id": 11,
          "alias": "11",
          "compt": "selectbox",
          "express": "like",
          "val": ['父级'],
          "range": null
        }]],
        model: 0
      };
      let formData = {
        page: 1,
        limit: 50,
        deptId: this.$route.query.fid,
        formId: 171924,
        searchStr: encodeURI(JSON.stringify(searchStr)),
        orderBy: 'startTime',
        orderType: 'desc'
      };
      this.$api.singleadvanceSearch(formData).then(res => {
        let list = _this.setDatas(res.dataList, 'list');
        this.exhibitions = list;
        this.$nextTick(() => {
          new Swiper(this.$refs.swiperWarp, {
            slidesPerView: 1.5,
            spaceBetween: -22,
            // loop: true,
            centeredSlides: true
          });
        });
      });
      if (this.$route.query.fid == 152288) {
        searchStr.filters[searchStr.filters.length - 1][0].val = ['子级'];
        formData.searchStr = encodeURI(JSON.stringify(searchStr));
        //子级列表
        this.$api.singleadvanceSearch(formData).then(res => {
          let list = _this.setDatas(res.dataList, 'list');
          this.childList = list;
        });
      }
    },
    setDatas(data, type) {
      return data.map(item => {
        return {
          exhibName: this.getFormData(item, 'name', 'val'),
          price: this.getFormData(item, 'expend', 'val'),
          exhibType: this.getFormData(item, 'type', 'val'),
          images: this.getFormData(item, 'image', 'fileUrl'),
          exhibitionLocation: this.getFormData(item, 'address', 'val'),
          exhibBegin: this.getFormData(item, 'startTime', 'val'),
          exhibEnd: this.getFormData(item, 'endTime', 'val'),
          code: this.getFormData(item, 10, 'val'),
          en_name: this.getFormData(item, 'en_name', 'val'),
          en_location: this.getFormData(item, 'en_location', 'val'),
          en_desc: this.getFormData(item, 'en_desc', 'val'),
          parentExhibitonName: this.getFormData(item, 12, 'val')
        };
      });
    },
    getFormData(data, Tkey, key) {
      data = data.formIdValueData;
      if (!data[Tkey]) return '';
      let target = data[Tkey].groupValues[0];
      if (!target) return '';
      return target.values.length && target.values[0] ? target.values[0][0] ? target.values[0][0][key] : '' : '';
    }
  },
  created() {
    this.getData();
    flexible();
    this.language = this.$route.query.language;
  },
  computed: {}
};